export default {
    name: 'aboutSection',
    title: 'About Section',
    type: 'document',
    fields: [
        { name: 'title', title: 'Title', type: 'string', validation: Rule => Rule.required() },
        { name: 'description', title: 'Description', type: 'array', of: [{ type: 'block' }], validation: Rule => Rule.required() },
        { name: 'image', title: 'Image', type: 'image', options: { hotspot: true }, validation: Rule => Rule.required() }
    ],
    preview: {
        select: {
            media: 'image'
        },
        prepare({ media }) {
            return {
                title: 'About Section',
                subtitle: 'Homepage about section content',
                media
            }
        }
    }
} 